import React from "react";
import { Navigation, Link } from "react-router";
import { Grid, Row, Col, Glyphicon} from "react-bootstrap";
import FontAwesome from "react-fontawesome";
import Api from "js/utilities/fnapi-client"
import { sidebarOnClicks, mountCode, initDeepLinkData, urlChangeHandler } from "js/utilities/sdk-doc-utils";
import UserHandler from "js/utilities/user-handler";
import SDKSidebar from "js/utilities/sdk-sidebar"
import ApptokenDisplay from "js/utilities/get-display-apptoken";
import AppnameDisplay from "js/utilities/get-display-appname";
import Loader from "react-loader";
import Zoom from "js/utilities/zoom-handler"
import Amplitude from "js/utilities/amplitude";
import { ZOOM_ICON } from "js/config.jsx";

export default React.createClass({
  mixins: [Navigation],

  displayName: "Submitting a Good Bug",

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },

  getInitialState() {
    var scrollToElement = initDeepLinkData(this.props);

    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    sidebarOnClicks();
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {
    var formattedSubject = "FaceTec Technical Support Request";
    var formattedBody = "Hello FaceTec Support,\n\n I would like to report an issue:\n";

    formattedBody += "\n<INSERT_PLATFORM_HERE> -- <INSERT HIGH LEVEL DESCRIPTION OF THE PROBLEM>"
    
    formattedBody += "\n\nSteps to reproduce:"

    formattedBody += "\n1. I have attached a Sample App that reproduces the issue on the latest (v8.X.X) version of the SDK. Run the attached Sample."
    formattedBody += "\n2. Describe the first step to take to reproduce the issue."
    formattedBody += "\n3. Describe additional steps to take to reproduce the issue."

    formattedBody += "\n\nExpected Behavior -- <DESCRIBE THE BEHAVIOR YOU EXPECT TO SEE>"

    formattedBody += "\n\nActual Behavior -- <DESCRIBE THE ACTUAL BEHAVIOR YOU GOT>"

    formattedBody += "\n\nDevice and Platform -- <DESCRIBE THE DEVICES AND PLATFORMS YOU TESTED THIS ON>"

    formattedBody += "\n\nReproducible in Demos or Samples -- <IS THIS ISSUE REPRODUCIBLE IN OUR LIVE DEMOS OR SAMPLES?>"

    formattedBody += "\n\nAttachments -- Here is are the runnable apps (including source code, not just an APK or IPA), screenshots, videos, logs, etc. that you need to reproduce and investigate the issue:\n\n<INSERT FILES OR FILE LINKS  HERE>"
    
    var mailToLink = "mailto:support@facetec.com?subject=" + formattedSubject + "&body=" + encodeURIComponent(formattedBody);

    return (
      <div className="dash">
        <div className="workspace">
          <div className="workspace__container">
            <section>
              <div className="title">
                <Glyphicon glyph="list" />
                <h2 id="requesting-support-issue-submission-policy">Send Issue Report / Request Technical Support</h2>
              </div>
              <p>Use this page to read about our Support Policies and Guidance.</p>
              <hr />
            </section>
            <section>
              <h3 id="issue-submission-policy">Technical Support Policies:</h3>
              <br />
              <ol>
                <li>FaceTec pledges to provide fast, thorough, and enthusiastic support to anyone that sends us great bug reports.</li>
                <li>If you send an issue report that does not provide sufficient information, we will not be able to assist you.</li>
                <li>Your support request MUST include a Runnable App (including source code, not just an APK or IPA) OR occur in one of our Public Demos.</li>
                <li>Please check whether this occurs in the latest version of FaceTec SDKs before contacting us.</li>
                <li>If the issue is happening in your App, you must reduce the issue to a smaller, minimum runnable app.</li>
                <li>Be explicit about the "Expected" behavior versus the "Actual" behavior.</li>
                <li>Be explicit about whether the issue reproduces every time, or if the issue is intermittent.</li>
                <li>If the issue is intermittent, spend time to narrow down the issue before contacting us so that we can reproduce the issue.</li>
                <li>If you provide a reproducible issue, we will likely be able to release a fix in our current release cycle (usually less than 2 weeks).</li>
              </ol>
              <hr />
            </section>

            <section>
              <h3 id="how-do-i-request-support">How Do I Request Support?</h3>
              <strong><p class="big" style={{marginTop: "15px", fontSize: "20px"}}><a href={mailToLink}>Click Here to Email FaceTec Support</a></p></strong>
              <hr />
            </section>

            <section>
              <h3 id="example-issue-report">Example Issue Report</h3>
              <p>If your issue is easily reproducible, great!  This means you just need to <strong>provide FaceTec with the collateral necessary to reproduce the issue</strong>. Here is an example of a GOOD issue report:</p>
              <blockquote>
                <p><strong>Title:</strong> ANDROID -- There is a slight hang/delay when pressing the cancel button during a User Session.</p>
                <p><strong>Steps to reproduce:</strong></p>
                <ol>
                  <li>I have attached a Sample App that reproduces the issue on the latest (v8.X.X) version of the SDK.  Run the attached Sample.</li>
                  <li>Press the Liveness Check button.</li>
                  <li>The Liveness Check interface will load.  Now press the Start button.</li>
                  <li>The session will start.  Once the session starts, press the cancel button.</li>
                </ol>
                <p><strong>Repros Every Time or Intermittent?</strong> -- This bug reproduces every time you perform the above steps.</p>
                <p><strong>Expected Behavior</strong> -- User Session closes immediately.</p>
                <p><strong>Actual Behavior</strong> -- After pressing cancel, User Session hangs for 1-2 seconds then closes.</p>
                <p><strong>Device and Platform</strong> -- This occurs on all 5 Android devices I tested on and does not occur on iOS or Browser platforms.</p>
                <p><strong>Reproducible in Demos or Samples</strong> -- This is also reproducible in your live Android FaceTec Demo Google Play App.</p>
                <p><strong>Attachments</strong> -- Here is a video of the behavior and the runnable sample (including source code, not just an APK or IPA) that reproduces this issue.</p>
                <p><strong>Other notes</strong> -- We are able to reproduce this on the majority of our devices on the latest SDK version.</p>
              </blockquote>
              <hr />
            </section>

            <section>
              <h3 id="key-requirements-for-submitting-good-bugs">Key Requirements for Submitting Good Bugs</h3>
              <br />
              <ol>
                <li>Provide explicit steps to reproduce the issue.</li>
                <li>Provide expected and actual behavior.</li>
                <li>Provide a runnable sample app (including source code, not just an APK or IPA), test case, repository, web page, or code that demonstrates the issue.  Remove extra code that is not required for the bug to reproduce.</li>
                <li>Provide a screenshot or video of the behavior.</li>
                <li>Provide all device and server logs related to the behavior you are seeing.</li>
                <li>Check the latest version of FaceTec SDKs and see if the behavior still reproduces there.  Note your results in your issue report.</li>
                <li>Does the issue reproduce in our Sample Apps, or is there a way to modify them to get them to reproduce the issue?  Note your results in your issue report.</li>
                <li>If the issue is an issue with an algorithm (Liveness, Matching, Age Check, Photo ID Matching, etc.), provide as many samples as possible (image data, if possible) that reproduce the issue.</li>
              </ol>
              <hr />
            </section>

            <section>
              <h3 id="additional-information">Additional Information To Provide for Specific Types of Bugs</h3>
              <br />
              <ol>
                <li>For <strong>crashes</strong>, please include the crash stack and <strong>all logs</strong> from the device/server.</li>
                <li>For <strong>UX issues</strong>, please include your FaceTec UI Customization code and a screenshot or video of the behavior.</li>
                <li>For <strong>memory issues</strong>, please provide a memory trace and a screenshot/video showing the memory issue.</li>
                <li>For <strong>CPU issues</strong>, please provide a CPU trace and a screenshot/video showing the CPU issue.</li>
                <li>For <strong>hangs</strong>, please provide a thread dump.</li>
                <li>For <strong>key/initialization issues</strong>, please provide your initialization code, the <code>ZoomSessionResult</code> you are getting, the result of calling <code>ZoomSDK.getStatus()</code> when the issue is reproducing, and the logs from your device/server.  We also need a runnable sample to reproduce the issue.</li>
                <li>If the bug is <strong>definitely a regression</strong>, please include information about the last release where this was working and relevant code from the previous version where this was working.</li>
              </ol>
              <hr />
            </section>

            <section>
              <h3 id="random-or-intermittent-issue">"My Issue/Bug is 'Random' or Intermittent"</h3>
              <br />
              <p>Most bugs are not truly intermittent, there is usually some set of steps to perform that will reproduce the issue.</p>
              <p><strong>If you send us an Issue Report that we cannot immediately reproduce with a runnable sample (including source code, not just an APK or IPA) and clear repro steps, we will unfortunately be unable to assist you.</strong></p>
              <p>So please,<strong>if you perceive the issue to be high priority or a blocker, spend the time to narrow down the issue and provide FaceTec with the ability to reproduce the issue in our own local environment</strong>.  If we can reproduce the issue, we will likely be able to quickly fix the issue and include it in our next release.</p>
              <hr />
            </section>


            <section>
              <h3 id="minimum-runnable-sample">"I can't provide you a Minimum Runnable Sample because I can't send you my organization's production app source code."</h3>
              <br />
              <p><strong>We **ARE NOT** asking for your production app source code, please do not send this to us!</strong></p>
              <p><strong>We **ARE** requiring that you to reduce the problem you are encountering down to a Minimum Runnable Sample that removes your organization's proprietary code in order to the demonstrate the issue</strong>.</p>
              <blockquote><p><strong>Minimum Runnable Samples and Clear Steps to Reproduce the Issue are not optional, they are required!</strong></p></blockquote>
              <hr />
            </section>

            <section>
              <h3 id="call-or-screenshare">"Can we just get on a call or screenshare to discuss or show you....?"</h3>
              <p>Our dev and support teams are extremely busy working on new features, major improvements to the product, <strong>and Good Issue Reports from our own team and from developers like you!</strong></p>
              <p><strong>Meetings and calls are inefficient</strong> because they take time to schedule and for both parties to get together.  They also require the direct attention of at least 1 person from both your team and ours. Even if we get on a call, <strong>the first things we will ask are the things listed on this page and in our support form</strong>.  So please, get us a Minimum Runnable Sample with Clear Steps to Reproduce and we will be able to quickly help you!</p>
              <hr />
            </section>


            <section>
              <h3 id="same-requirements">Our Requirements are the same as Microsoft, Google, Apple, and more!</h3>
              <p><strong>FaceTec's Issue Reporting Guidelines are the same as the World's top software companies.</strong></p>
              <p>Here is guidance from some of the top software companies and open source projects in the world, and our favorite advice from each:</p>
              <br />
              <h4>Google</h4>
              <ul className="issueReportGuidanceList">
                <li><a target="_blank" href="https://developers.google.com/web/feedback/file-a-bug">Google Guide - Submitting bugs (Chrome).</a></li>
                <ul>
                  <li>"Create a minimized test case."</li>
                  <li>"To make a long story short, while a description of the problem is a great start, nothing beats providing a link... in the bug that demonstrates the problem. To maximize the chance of fast progress the example should contain the minimum possible code needed to demonstrate the problem. A minimal code sample is the number one thing you can do to increase the odds of your bug getting fixed."</li>
                </ul>
                <li><a target="_blank" href="https://source.android.com/setup/contribute/report-bugs">Google Guide - Submitting bugs (Android).</a></li>
                <ul>
                  <li>"A bug that simply says something isn't working doesn't help much, and will probably be closed without any action. The amount of detail that you provide, such as log files, repro steps, and even a patch set, helps us address your issue."</li>
                </ul>

                <li><a target="_blank" href="https://developer.android.com/studio/report-bugs">Google Guide - Submitting bugs (Studio).</a></li>
                <ul>
                  <li>"We want to fix your bugs! But many bugs don't include required information. So we are focusing our limited resources on bugs that have complete reports. To improve the chances of your bug being fixed, please take a moment to read this document."</li>
                  <li>"If you don't follow these steps, we will close your bug. If that happens, simply resubmit with the additional information."</li>
                  <li>"Describe the exact steps to reproduce. If we can reproduce the issue on the first try, the odds of a fix are much better. If possible, include a code snippet (or better yet, point to a github project which can be used to reproduce the bug). Screenshots are also helpful to show what you are observing."</li>
                </ul>
              </ul>

              <h4>Microsoft</h4>
              <ul className="issueReportGuidanceList">
                <li><a target="_blank" href="https://github.com/microsoft/vscode/wiki/Submitting-Bugs-and-Suggestions">Microsoft Guide - Submitting Bugs (Visual Studio)</a></li>
                <ul>
                  <li>"[Please include] Reproducible steps (1... 2... 3...) and what you expected versus what you actually saw."</li>
                  <li>"Images, animations, or a link to a video. Note that images and animations illustrate repro-steps but do not replace them."</li>
                  <li>"[Please include] code snippet that demonstrates the issue or a link to a code repository we can easily pull down onto our machine to recreate the issue."</li>
                </ul>
              </ul>

              <h4>Apple</h4>
              <ul className="issueReportGuidanceList">
                <li><a target="_blank" href="https://swift.org/contributing/#reporting-bugs">Apple Guide - Reporting Bugs (Visual Studio)</a></li>
                <ul>
                  <li>"[Please include] a reproducible test case. If the test case is small (for example, less than 20 lines of code) paste it directly into the issue’s description field. Otherwise, upload it as an attachment to the Jira issue."</li>
                  <li>"For a bug to be actionable, it needs to be reproducible. If you can’t reproduce the bug, try to figure out why."</li>
                </ul>
              </ul>

              <h4>More Top Tech Organizations</h4>
              <ul className="issueReportGuidanceList">
                <li><a target="_blank" href="https://developer.mozilla.org/en-US/docs/Mozilla/QA/Bug_writing_guidelines">Submitting bugs to Mozilla (Firefox).</a></li>
                <ul>
                  <li>"How can [FaceTec] reproduce the bug...?  Steps to reproduce are the most important part of any bug report. If [FaceTec] is able to reproduce the bug, the bug is very likely to be fixed. If the steps are unclear, it might not even be possible to know whether the bug has been fixed."</li>
                </ul>

                <li><a target="_blank" href="https://www.chiark.greenend.org.uk/~sgtatham/bugs.html">How to Report Bugs Effectively, by the creator of PuTTY (1999)</a></li>
                <ul>
                  <li>"If you have to report a bug to a programmer who can't be present in person, the aim of the exercise is to enable them to reproduce the problem. You want the programmer to run their own copy of the program, do the same things to it, and make it fail in the same way. When they can see the problem happening in front of their eyes, then they can deal with it."</li>
                </ul>

                <li><a target="_blank" href="http://testthewebforward.org/docs/bugs.html">W3C Guide - How to Report a Bug</a></li>
                <ul>
                  <li>"The goal of reproducible steps is to teach [FaceTec] to recreate the bug on his own system. It may be as simple as Load the attached [app/page/code] in Browser XYZ."</li>
                  <li>"Reduced Test Case - The goal of test case is to pinpoint the bug. A Reduced Test Case rips out everything in the [page/app] that is not required to reproduce the bug. Also try variations on the test case to find related situations that also trigger the bug."</li>
                </ul>

                <li><a target="_blank" href="https://www.kernel.org/doc/html/latest/admin-guide/reporting-bugs.html">The Linux Foundation Guide - Reporting bugs</a></li>
                <ul>
                  <li>"The most important information in a bug report is how to reproduce the bug. This includes system information, and (most importantly) step-by-step instructions for how a user can trigger the bug."</li>
                </ul>
              </ul>

            </section>

            <SDKSidebar menuType="main" title="Submitting a Good Bug Report"/>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/submitting-a-good-bug.jsx